import React, { useState, useEffect } from 'react';

//import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//import { faStar } from '@fortawesome/free-solid-svg-icons';
import { Link } from "react-router-dom";

import NewHeader from "./Component/NewHeader/NewHeader";
import moment from 'moment';
import {Helmet} from "react-helmet";

import './BookingPage.css'
import BookingPageSkeleton from './BookingPageSkeleton';

function AgentBookingPage(props) {

    const [HotelImage, setHotelImage] = useState();
   // const [HotelData, setHotelData] = useState({});
    const [StartDate, setCheckIn] = useState();
    const [Time, setTime] = useState(null);
    const [PaymentPriceType, setPaymentPriceType] = useState(null);
    const [TourLocation, setTourLocation] = useState(null);
    const [TourName, setTourName] = useState(null);
    const [GuestCount, setGuestCount] = useState([]);
    const [TransactionID, setTransactionID] = useState();
   


    // const starsCount = () => {
    //     console.log(HotelData.star_category_id);
    //     if (HotelData.star_category_id == 1) {
    //         return (
    //             <>
    //                 <FontAwesomeIcon icon={faStar} color='#000'></FontAwesomeIcon>
    //                 <FontAwesomeIcon icon={faStar} color='#ccc'></FontAwesomeIcon>
    //                 <FontAwesomeIcon icon={faStar} color='#ccc'></FontAwesomeIcon>
    //                 <FontAwesomeIcon icon={faStar} color='#ccc'></FontAwesomeIcon>
    //                 <FontAwesomeIcon icon={faStar} color='#ccc'></FontAwesomeIcon>
    //             </>
    //         )
    //     } else if (HotelData.star_category_id == 2) {
    //         return (
    //             <>
    //                 <FontAwesomeIcon icon={faStar} color='#000'></FontAwesomeIcon>
    //                 <FontAwesomeIcon icon={faStar} color='#000'></FontAwesomeIcon>
    //                 <FontAwesomeIcon icon={faStar} color='#ccc'></FontAwesomeIcon>
    //                 <FontAwesomeIcon icon={faStar} color='#ccc'></FontAwesomeIcon>
    //                 <FontAwesomeIcon icon={faStar} color='#ccc'></FontAwesomeIcon>
    //             </>
    //         )
    //     } else if (HotelData.star_category_id == 3) {
    //         return (
    //             <>
    //                 <FontAwesomeIcon icon={faStar} color='#000'></FontAwesomeIcon>
    //                 <FontAwesomeIcon icon={faStar} color='#000'></FontAwesomeIcon>
    //                 <FontAwesomeIcon icon={faStar} color='#000'></FontAwesomeIcon>
    //                 <FontAwesomeIcon icon={faStar} color='#ccc'></FontAwesomeIcon>
    //                 <FontAwesomeIcon icon={faStar} color='#ccc'></FontAwesomeIcon>
    //             </>
    //         )
    //     } else if (HotelData.star_category_id == 4) {
    //         return (
    //             <>
    //                 <FontAwesomeIcon icon={faStar} color='#000'></FontAwesomeIcon>
    //                 <FontAwesomeIcon icon={faStar} color='#000'></FontAwesomeIcon>
    //                 <FontAwesomeIcon icon={faStar} color='#000'></FontAwesomeIcon>
    //                 <FontAwesomeIcon icon={faStar} color='#000'></FontAwesomeIcon>
    //                 <FontAwesomeIcon icon={faStar} color='#ccc'></FontAwesomeIcon>
    //             </>
    //         )
    //     } else if (HotelData.star_category_id == 5) {
    //         return (
    //             <>
    //                 <FontAwesomeIcon icon={faStar} color='#000'></FontAwesomeIcon>
    //                 <FontAwesomeIcon icon={faStar} color='#000'></FontAwesomeIcon>
    //                 <FontAwesomeIcon icon={faStar} color='#000'></FontAwesomeIcon>
    //                 <FontAwesomeIcon icon={faStar} color='#000'></FontAwesomeIcon>
    //                 <FontAwesomeIcon icon={faStar} color='#000'></FontAwesomeIcon>
    //             </>
    //         )
    //     }

    // }

    useEffect(() => {

        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const checkin = urlParams.get('checkin');
       const query = urlParams.get('query');
        const hotelImage = urlParams.get('hotelImage');
        const tour_location = urlParams.get('tour_location');
        const tourName = urlParams.get('tourName');
        
        const tour_time = urlParams.get('tour_time');
        const data = urlParams.get('data');
        const PriceType = urlParams.get('PriceType');
       
        let querySearch = JSON.parse(query);
     
        setHotelImage(hotelImage);
     
        setCheckIn(checkin);
        setGuestCount(querySearch);
        setTourLocation(tour_location);
        setTourName(tourName);
        setTime(tour_time);
        setPaymentPriceType(PriceType);
       

    }, [])

    console.log(TransactionID);
   // console.log(HotelData.id);
    return (
        <>
         <Helmet>
            <title> Booking Confirmation @ Holidays Seychelles</title>
            <meta name="keywords" content="Seychelles, Seychellen, best place for honeymoon,most beautiful places in the world,best honeymoon destination in the world,honeymoon places,honeymoon destinations,beautiful places in the world"/>
        </Helmet>
        <h1 style={{color:'#fff'}}> Booking Confirmation @ Holidays Seychelles</h1>
            <NewHeader page={'inner_listing'} />
            {Time == null ? (
                <BookingPageSkeleton />
            ) : (
                <div className="container makeFlex spaceBetween">

                    <div className="container makeFlex spaceBetween" style={{ padding: '50px' }}>
                        <div className="Container-TileBooking" style={{ marginTop: 90, height: 360, padding: 40 }}>

                            <div className="Detail-Hotel">
                                <div className="Hotel-Name" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <div className="nameContainer" style={{ width: 600 }}>

                                        <div className="paymakeFlex appendBottom5"><h3 className="latoBlack font22 blackText">{TourName}</h3></div>
                                        <p>{TourLocation}</p>
                                        <h3 className="latoBlack font22 blackText" style={{ marginTop: 10, fontSize: 18, fontWeight: 'bold' }}>Status: ACCEPT</h3>
                                      

                                        <div class="chkContBooking">
                                            <div class="chkCont__col">
                                                <div class="paymakeFlex column">
                                                    <span class="font10 grayText appendBottom3">CHECK IN</span><span class="latoBlack font24 blackText appendBottom3">{moment(StartDate).format("D MMM Y")}</span><span class="font10 grayText 444">{moment(StartDate).format('dddd')}, </span>
                                                </div>
                                                <div class="chkCont__night"><span></span></div>
                                                <div class="paymakeFlex column">
                                                    <span class="font10 grayText appendBottom3">Time</span><span class="latoBlack font24 blackText appendBottom3">{Time}</span>
                                                </div>
                                            </div>
                                            <div class="chkCont__col"><p class="font16 blackText">

                                            {PaymentPriceType == 1 ? (<>
                                                    {GuestCount.reduce((a, v) => a + (v.adultCounter * 1), 0) > 0 && <><span class="latoBlack">{GuestCount.reduce((a, v) => a + (v.adultCounter * 1), 0)}</span>&nbsp;Adults,&nbsp;</>}

                                                    {GuestCount.reduce((a, v) => a + (v.childCounter * 1), 0) > 0 && <><span class="latoBlack">{GuestCount.reduce((a, v) => a + v.childCounter * 1, 0)}</span>&nbsp;Children&nbsp;</>}

                                                    {GuestCount.reduce((a, v) => a + (v.infantCounter * 1), 0) > 0 && <><span class="latoBlack">{GuestCount.reduce((a, v) => a + (v.infantCounter * 1), 0)}</span>&nbsp;Infant,&nbsp;</>}

                                                    {GuestCount.reduce((a, v) => a + (v.youthCounter * 1), 0) > 0 && <><span class="latoBlack">{GuestCount.reduce((a, v) => a + (v.youthCounter * 1), 0)}</span>&nbsp;Youth,&nbsp;</>}

                                                    {GuestCount.reduce((a, v) => a + (v.SeniorCounter * 1), 0) > 0 && <><span class="latoBlack">{GuestCount.reduce((a, v) => a + (v.seniorCounter * 1), 0)}</span>&nbsp;Senior,&nbsp;</>}
                                                </>) : (<>
                                                    {GuestCount.reduce((a, v) => a + (v.groupCounter * 1), 0) > 0 && <><span class="latoBlack">{GuestCount.reduce((a, v) => a + (v.groupCounter * 1), 0)}</span>&nbsp;Travelers,&nbsp;</>}
                                                </>)}
                                            </p></div>

                                        </div>

                                        <p class="errorLinkText latoBold font16 blueText"><Link to="/home">Back To Home Page</Link></p>
                                    </div>
                                    <div className="imageContainerBooking">
                                        <img src={HotelImage} style={{ width: '100%' }} />
                                    </div>
                                </div>


                            </div>

                        </div>
                    </div>
                </div>
            )}



        </>
    )
}

export default AgentBookingPage;
